/**
 * Date utility functions for ISO 8601 date formatting (YYYY-MM-DD)
 *
 * ISO 8601 is the only sensible date format:
 * - Sorts correctly
 * - Unambiguous globally
 * - Even Americans can't mess it up
 */
/**
 * Format a date string or Date object to ISO format (YYYY-MM-DD)
 * @param date - Date string, Date object, or null/undefined
 * @returns Formatted date string in YYYY-MM-DD format, or empty string if invalid
 */
export function formatDate(date) {
    if (!date)
        return '';
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(dateObj.getTime()))
        return '';
    return dateObj.toISOString().split('T')[0];
}
/**
 * Convert a date to YYYY-MM-DD format for HTML date inputs
 * @param date - Date string, Date object, or null/undefined
 * @returns Date string in YYYY-MM-DD format, or empty string if invalid
 */
export function toDateInputValue(date) {
    if (!date)
        return '';
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(dateObj.getTime()))
        return '';
    return dateObj.toISOString().split('T')[0];
}
/**
 * Get current date in YYYY-MM-DD format for HTML date inputs
 * @returns Current date in YYYY-MM-DD format
 */
export function getCurrentDateInputValue() {
    return new Date().toISOString().split('T')[0];
}
/**
 * Format date for filename exports (YYYY-MM-DD)
 * @param date - Date object or undefined (defaults to now)
 * @returns Date string formatted as YYYY-MM-DD
 */
export function formatDateForFilename(date) {
    const dateObj = date || new Date();
    return dateObj.toISOString().split('T')[0];
}
/**
 * Format date with time in ISO format (YYYY-MM-DD HH:mm)
 * @param date - Date string, Date object, or null/undefined
 * @returns Formatted date string with time, or empty string if invalid
 */
export function formatDateTime(date) {
    if (!date)
        return '';
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(dateObj.getTime()))
        return '';
    const datePart = dateObj.toISOString().split('T')[0];
    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    return `${datePart} ${hours}:${minutes}`;
}
